import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { order, message, getTypePrefix  } from '@/api'

/**
 * 消息列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryUserOrderMessageAction = createAsyncThunk(
    getTypePrefix(message.queryUserOrderMessage),
    async (data) => await okHttp(message.queryUserOrderMessage, {
        method: 'POST',
	    data
    })
)

/**
 * 更新消息状态
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const updateOrderMessageStatusAction = createAsyncThunk(
    getTypePrefix(message.updateOrderMessageStatus),
    async (data) => await okHttp(message.updateOrderMessageStatus, {
        method: 'POST',
	    data
    })
)

/**
 * 获取订单详情
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getOrderDetailAction = createAsyncThunk(
    getTypePrefix(`${order.getEshopOrderInfoByCodeUrl}_servicio_message`),
    async (params) => await okHttp(order.getEshopOrderInfoByCodeUrl, {
        method: 'GET',
        params
    })
)

/**
 * 获取售后单详情
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryRefundDetailAction = createAsyncThunk(
    getTypePrefix(`${order.queryRefundDetailUrl}_servicio_message`),
    async (params) => await okHttp(order.queryRefundDetailUrl, {
        method: 'GET',
        params
    })
)
